import OutBrain from "common/Layout/Adverts/OutBrain";
import { FC, useContext } from "react";
import { SideBarProps } from "../types/Article.types";
import Topics from "../Topics";
import {
  SideBarWrapper,
  OutbrainWrapper,
  SideBarMpuWrapper,
} from "./SideBar.styled";
import MPU from "common/Layout/Adverts/SideBarMPU";
import { ArticleContext } from "../Context";
import { articleTypes } from "../Context/ArticleContext";

interface Props {
  sidebarContent: SideBarProps;
  type: string;
}

// MPU ids for sidebar
const SIDEBAR_MPUS = ["mpu2", "sticky-mpu"];

const SideBar: FC<Props> = ({ sidebarContent, type }) => {
  const { isDisableOutbrain, refactoredArticle } =
    useContext<articleTypes>(ArticleContext);

  if (!sidebarContent || type === "Service" || type === "Commercial") {
    return null;
  }

  const mpuIds = [...SIDEBAR_MPUS];

  return (
    <SideBarWrapper>
      {sidebarContent.map((item, i) => {
        if (item.type === "MostPopular") {
          return <Topics key={i} />;
        }

        if (item.type === "Outbrain" && !isDisableOutbrain) {
          return (
            <OutbrainWrapper key={i}>
              <OutBrain id="AR_2" contentUrl={refactoredArticle?.url} />
            </OutbrainWrapper>
          );
        }

        if (item.type === "Ad") {
          const id = mpuIds.shift();
          if (!id) return null;

          const isSticky = id === "sticky-mpu";

          return (
            <SideBarMpuWrapper key={i} sticky={isSticky}>
              <MPU className="article_sidebar" id={id} />
            </SideBarMpuWrapper>
          );
        }

        return null; // fallback if item.type is unrecognized
      })}
    </SideBarWrapper>
  );
};

export default SideBar;
